import React from 'react';
import classNames from 'classnames';
import { t } from '../../../../../i18n';
import './styles.scss';

const Instructor = ({ author, className }) => {
  return (
    <div className={classNames("specific-course-screen__instructor", className)}>
      <div className="specific-course-screen__instructor-header">
        <img src={author.avatarImageUrl} alt={author.fullName} />
        <div>
          <p>{t('DIGITAL_COURSES.SPECIFIC_COURSE_SCREEN.INSTRUCTOR')}</p>
          <b>{author.fullName}</b>
        </div>
      </div>
      <div className="specific-course-screen__instructor-summary">
        <p>{author.summary}</p>
      </div>
    </div>
  );
};

export default Instructor;
